var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 4194"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00004 8.00081C4.00003 7.824 4.07025 7.65443 4.19527 7.52939L9.5286 2.1952C9.78893 1.93483 10.211 1.93479 10.4714 2.19512C10.7318 2.45545 10.7318 2.87756 10.4715 3.13793L5.60952 8.00068L10.4714 12.8618C10.7318 13.1221 10.7318 13.5442 10.4715 13.8046C10.2112 14.065 9.78905 14.065 9.52868 13.8047L4.19534 8.4722C4.07031 8.34719 4.00006 8.17762 4.00004 8.00081Z",
    fill: "#CCCCCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterArrow);
export default __webpack_public_path__ + "static/media/footer-arrow.ea9a38a9021b0bf969d273841bb5a12c.svg";
export { ForwardRef as ReactComponent };